import { render } from "./HorizontalBannerTopLatest.vue?vue&type=template&id=0090732e"
import script from "./HorizontalBannerTopLatest.vue?vue&type=script&lang=js"
export * from "./HorizontalBannerTopLatest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__